export const APPLIED = 'APPLIED';
export const SAVED = 'SAVED';

export const USER_PREFERENCES_KEY = 'userPreferences';

export const APPLIED_ROUTE = '/my-activity/applied-jobs';
export const SAVED_ROUTE = '/my-activity/saved-jobs';

export const MAX_ITEMS = 100;
export const NODES_PER_PAGE = 20;
export const RETENTION_TIME_SAVED = 180;
export const RETENTION_TIME_APPLIED = 90;

export const JOB_TYPE = { applied: 'applied', saved: 'saved' };

export const RESUME = 'resume';
export const COVER_LETTER = 'cover letter';

export const NUM_JOB_RECS = 6;
